export const cf2imgix = (cfUrl = '') => {
  const url = global.decodeURIComponent(
    cfUrl
      .replace(
        /(https?:)?\/\/(downloads|images).ctfassets.net\//g,
        'https://img.uswitch.com/'
      )
      // imgix expects unencoded string for URL and treats + as encoded space
      .replace(/\+/g, ' ')
  )

  return url
}
